import React from "react"
import classes from "./CustomCalendarWeekHead.module.css"

interface Props {
  className?: string
}

const CustomCalendarWeekHead = ({ className }: Props) => {
  return (
    <div className={`${classes.row} ${className ?? ""}`}>
      {["LUN", "MAR", "MER", "GIO", "VEN", "SAB", "DOM"].map((x) => (
        <div key={x} className={classes.day}>
          {x}
        </div>
      ))}
    </div>
  )
}

export default CustomCalendarWeekHead
